import React from 'react';
import IconBase from './IconBase';

const BookmarkAddIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M28.9,17.5c-1.8-0.3-3.3-1.2-4.6-2.7c-1.2-1.4-1.8-3.1-1.8-5c0-1,0.2-1.9,0.5-2.7c0.3-0.8,0.8-1.6,1.4-2.3H11.1c-0.8,0-1.4,0.3-2,0.8c-0.6,0.6-0.8,1.2-0.8,2V35L20,30l11.7,5V17.5c-0.5,0.1-1,0.1-1.4,0.1S29.4,17.6,28.9,17.5z"/>
            <polygon points="35.3,8.5 31.7,8.5 31.7,4.9 28.9,4.9 28.9,8.5 25.3,8.5 25.3,11.2 28.9,11.2 28.9,14.9 31.7,14.9 31.7,11.2 35.3,11.2 	"/>
        </IconBase>
    )
}

export default BookmarkAddIcon;